React = require 'react'
FormFields = require './internal/form-fields'
t = require('views/internal/recup-with-helpers')('credit_card')
_ = require 'underscore'
xtend = require 'xtend'
t = require('views/internal/recup-with-helpers')('credit_card')
f = require 'effing'

localizeCountry = ([value, key]) -> [value, t.l(['countries', key])]

module.exports = class extends React.Component
  displayName: 'AdditionalDetailsComponent'

  formFields: [
    'invoiceDetails'
  ]
  requiredFields: {}

  constructor: (props) ->
    super(props)

    @state = { submitting: false }

  render: t.renderable ->
    { submitting } = @state
    { onSubmit } = @props

    render = ({ formState, controlledOpts, getData }) =>
      onSubmitClick = (e) =>
        @setState(submitting: true)
        getData().then(onSubmit).done()

      opts = controlledOpts('invoiceDetails')

      t.div '.u-clearfix', ->
        t.form { onSubmit, ref: 'form' }, ->

          t.div '.additional-details-section.u-clearfix', ->
            t.div '.invoice-details', ->
              t.label ->
                t.textarea '.invoice-details-textarea', xtend opts,
                  readOnly: submitting
                  maxLength: 1024
                  placeholder: t.l('additional-details-placeholder')

        t.div ->
          t.button '.primary', {
            onClick: onSubmitClick
            disabled: submitting
            class: t.classify(disabled: submitting)
          }, ->
            t.format 'save'

    t.tag FormFields, {
      @formFields
      @requiredFields
      ref: (formFieldsRef) => @formFieldsRef = formFieldsRef
      initialState: {
        invoiceDetails: @props.initialValue
      }
      render
    }



// WEBPACK FOOTER //
// ./app/scripts/views/billing/form-sections/additional-details-component.coffee